export default "__VITE_ASSET__B7EKX$5p__"